module.exports = __webpack_public_path__ + "img/home_two_table_top_right.0a8d678f.png";